import type {ProfileModelType} from "#shared-package/profile-model.ts";

export function getKaid(
    profile?: ProfileModelType | null,
): string | null | undefined {
    return profile ? profile.get("kaid") : null;
}

export function getUserId(
    profile?: ProfileModelType | null,
): string | null | undefined {
    return profile ? profile.get("userId") : null;
}
